export const NOTIFICATION_TOKEN = "NOTIFICATION_TOKEN";
export const SET_NOTIFICATIONS_ENABLED = "SET_NOTIFICATIONS_ENABLED"